module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_5010.c1bf1250.png";